import React from 'react'
import PropTypes from 'prop-types'
import AdviserProfileBlurb from '../../../common/AdviserProfiles/AdviserProfileBlurb'
import * as styles from './_AdviserProfileBlurbEditor.scss'
import FieldGroup from '../../../common/forms/FieldGroup'
import FieldGroupTextArea from '../../../common/forms/FieldGroupTextArea'
import { connect } from 'react-redux'
import { actions } from './adviserProfileBlurbEditorActions'
import { bindActionCreators } from 'redux'

class AdviserProfileBlurbEditor extends React.Component {
  static propTypes = {
    profile: PropTypes.object.isRequired,
    editing: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    startEditing: PropTypes.func.isRequired,
    stopEditing: PropTypes.func.isRequired,
    setAdviserFirstName: PropTypes.func.isRequired,
    setAdviserMiddleName: PropTypes.func.isRequired,
    setAdviserLastName: PropTypes.func.isRequired,
    setAdviserTitle: PropTypes.func.isRequired,
    setAdviserCompany: PropTypes.func.isRequired,
    setAdviserCompanyWebsite: PropTypes.func.isRequired,
    setAdviserBuildingDetails: PropTypes.func.isRequired,
    setAdviserStreetAddress: PropTypes.func.isRequired,
    setAdviserSuburb: PropTypes.func.isRequired,
    setAdviserPostalCode: PropTypes.func.isRequired,
    setAdviserCity: PropTypes.func.isRequired,
    setAdviserLatitude: PropTypes.func.isRequired,
    setAdviserLongitude: PropTypes.func.isRequired,
    setAdviserDescription: PropTypes.func.isRequired,
    cancelEditingAdviserProfileBlurb: PropTypes.func.isRequired,
    formIsValid: PropTypes.bool.isRequired,
    validationstate: PropTypes.object.isRequired,
    submitting: PropTypes.bool.isRequired,
    children: PropTypes.object
  };

  constructor (props) {
    super(props)
    this.renderPreview = this.renderPreview.bind(this)
    this.renderEditor = this.renderEditor.bind(this)
    this.handleTitleChange = this.handleTitleChange.bind(this)
    this.handleCompanyChange = this.handleCompanyChange.bind(this)
    this.handleCompanyWebsiteChange = this.handleCompanyWebsiteChange.bind(this)
    this.handleBuildingDetailsChange = this.handleBuildingDetailsChange.bind(this)
    this.handleStreetAddressChange = this.handleStreetAddressChange.bind(this)
    this.handleSuburbChange = this.handleSuburbChange.bind(this)
    this.handlePostalCodeChange = this.handlePostalCodeChange.bind(this)
    this.handleCityChange = this.handleCityChange.bind(this)
    this.handleFirstNameChange = this.handleFirstNameChange.bind(this)
    this.handleMiddleNameChange = this.handleMiddleNameChange.bind(this)
    this.handleLastNameChange = this.handleLastNameChange.bind(this)
  }

  renderPreview () {
    return <AdviserProfileBlurb profile={this.props.profile} >
      {this.props.children}
    </AdviserProfileBlurb>
  }

  handleTitleChange (value) {
    this.props.setAdviserTitle(value)
  }

  handleCompanyChange (value) {
    this.props.setAdviserCompany(value)
  }

  handleCompanyWebsiteChange (value) {
    this.props.setAdviserCompanyWebsite(value)
  }

  handleBuildingDetailsChange (value) {
    this.props.setAdviserBuildingDetails(value)
  }

  handleStreetAddressChange (value) {
    this.props.setAdviserStreetAddress(value)
    this.props.setAdviserLatitude(null)
    this.props.setAdviserLongitude(null)
  }

  handleSuburbChange (value) {
    this.props.setAdviserSuburb(value)
    this.props.setAdviserLatitude(null)
    this.props.setAdviserLongitude(null)
  }

  handlePostalCodeChange (value) {
    this.props.setAdviserPostalCode(value)
    this.props.setAdviserLatitude(null)
    this.props.setAdviserLongitude(null)
  }

  handleCityChange (value) {
    this.props.setAdviserCity(value)
    this.props.setAdviserLatitude(null)
    this.props.setAdviserLongitude(null)
  }

  handleFirstNameChange (value) {
    this.props.setAdviserFirstName(value)
  }

  handleMiddleNameChange (value) {
    this.props.setAdviserMiddleName(value)
  }

  handleLastNameChange (value) {
    this.props.setAdviserLastName(value)
  }

  renderEditor () {
    const validationstate = this.props.validationstate
    const profile = this.props.profile
    return <form className={styles['form-blurb']}>
      <h2 className={styles['adviser-name']}>
        {profile.adviserName}
      </h2>
      <FieldGroup
        required
        disabled={this.props.submitting}
        value={profile.firstName}
        handleChange={this.handleFirstNameChange}
        label='First Name'
        message={validationstate.firstName.message}
        isInvalid={validationstate.firstName.isInvalid}
      />
      <FieldGroup
        disabled={this.props.submitting}
        value={profile.middleName || ''}
        handleChange={this.handleMiddleNameChange}
        label='Middle Name'
        message={validationstate.middleName.message}
        isInvalid={validationstate.middleName.isInvalid}
      />
      <FieldGroup
        required
        disabled={this.props.submitting}
        value={profile.lastName}
        handleChange={this.handleLastNameChange}
        label='Last Name'
        message={validationstate.lastName.message}
        isInvalid={validationstate.lastName.isInvalid}
      />
      <FieldGroup
        required
        disabled={this.props.submitting}
        value={profile.title}
        handleChange={this.handleTitleChange}
        label='Job Title'
        message={validationstate.title.message}
        isInvalid={validationstate.title.isInvalid}
        />
      <FieldGroup
        required
        disabled={this.props.submitting}
        value={profile.company}
        handleChange={this.handleCompanyChange}
        label='Company'
        message={validationstate.company.message}
        isInvalid={validationstate.company.isInvalid}
      />
      <FieldGroup
        disabled={this.props.submitting}
        value={profile.companyWebsite || ''}
        handleChange={(val) => { this.handleCompanyWebsiteChange(val) }}
        label='Company Website'
        message={validationstate.companyWebsite.message}
        isInvalid={validationstate.companyWebsite.isInvalid}
      />
      <FieldGroup
        disabled={this.props.submitting}
        value={profile.buildingDetails || ''}
        handleChange={(val) => { this.handleBuildingDetailsChange(val) }}
        label='Complex/Building details'
        message={validationstate.buildingDetails.message}
        isInvalid={validationstate.buildingDetails.isInvalid}
      />
      <FieldGroup
        required
        disabled={this.props.submitting}
        value={profile.streetAddress}
        handleChange={(val) => { this.handleStreetAddressChange(val) }}
        label='Street address'
        message={validationstate.streetAddress.message}
        isInvalid={validationstate.streetAddress.isInvalid}
      />
      <FieldGroup
        required
        disabled={this.props.submitting}
        value={profile.suburb}
        handleChange={(val) => { this.handleSuburbChange(val) }}
        label='Suburb'
        message={validationstate.suburb.message}
        isInvalid={validationstate.suburb.isInvalid}
      />
      <FieldGroup
        disabled={this.props.submitting}
        value={profile.postalCode || ''}
        handleChange={(val) => { this.handlePostalCodeChange(val) }}
        label='Postal Code'
        message={validationstate.postalCode.message}
        isInvalid={validationstate.postalCode.isInvalid}
      />
      <FieldGroup
        required
        disabled={this.props.submitting}
        value={profile.city}
        handleChange={(val) => { this.handleCityChange(val) }}
        label='City/Town'
        message={validationstate.city.message}
        isInvalid={validationstate.city.isInvalid}
      />
      <FieldGroupTextArea
        required
        disabled={this.props.submitting}
        value={profile.blurb}
        handleChange={(val) => { this.props.setAdviserDescription(val) }}
        label='Business Description'
        message={validationstate.businessDescription.message}
        isInvalid={validationstate.businessDescription.isInvalid}
      />
    </form>
  }

  render () {
    if (this.props.editing || this.props.submitting) {
      return this.renderEditor()
    }
    return this.renderPreview()
  }
}

const mapStateToProps = ({adviserProfileEditorContainer}) => {
  return {
    editing: adviserProfileEditorContainer.blurb.editingBlurb,
    loading: adviserProfileEditorContainer.blurb.loadingBlurb,
    formIsValid: adviserProfileEditorContainer.blurb.isInvalid.formIsValid,
    validationstate: adviserProfileEditorContainer.blurb.isInvalid,
    submitting: adviserProfileEditorContainer.blurb.submitting
  }
}

const mapDispatchToProps = (dispatch) => {
  const { edit, set } = actions
  return bindActionCreators({
    startEditing: edit.start,
    stopEditing: edit.stop,
    setAdviserFirstName: set.firstName,
    setAdviserMiddleName: set.middleName,
    setAdviserLastName: set.lastName,
    setAdviserTitle: set.investorTitle,
    setAdviserCompany: set.investorCompany,
    setAdviserBuildingDetails: set.investorBuildingDetails,
    setAdviserStreetAddress: set.investorStreetAddress,
    setAdviserSuburb: set.investorSuburb,
    setAdviserPostalCode: set.investorPostalCode,
    setAdviserCity: set.investorCity,
    setAdviserLatitude: set.latitudeStreetAddress,
    setAdviserLongitude: set.longitudeStreetAddress,
    setAdviserCompanyWebsite: set.investorCompanyWebsite,
    setAdviserDescription: set.investorDescription,
    cancelEditingAdviserProfileBlurb: edit.cancel
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)( (AdviserProfileBlurbEditor))
